export enum UiMessageType {
  ERROR = 'ERROR'
}
